export default __webpack_public_path__ + "52b59c2b38833ff9575e5623b391ba15.png";